export default __webpack_public_path__ + "3eb260f.png";